/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import {
  Grid,
  Box,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import './ApplyAirTicket.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import _ from 'lodash';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import moment from 'moment';

import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import { fonts, themes } from '../../../themes/themes';
import { toast } from 'react-hot-toast';
import Loader from '../../../Lottifiers/Loader/Loader';
import { getEmpTicketTypes } from '../../../configs/utils';
import CompDirection from '../../../themes/CompDirection';
import { DatePickerInput } from '../../../../components';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allTripTypes: any;
  allCountries: any;
  benefitStatus: string;
  callBackGetData: (data: any) => void;
  isLoading: boolean;
  trans?: any;
  i18n?: any;
}

const ApplyAirTicketPresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allTripTypes,
  allCountries,
  benefitStatus,
  isLoading,
  trans,
  i18n,
}: ModalProps) => {
  const [remarks, setRemarks] = useState('');
  const [amount, setAmount] = useState('');
  const [ticketRequest, setTicketRequest] = useState('');
  const [ticketRequestId, setTicketRequestId] = useState<any>();
  const [countryName, setCountryName] = useState('');

  const [, setCountryId] = useState(0);
  const [travelDate, setTravelDate] = useState<any>(new Date());
  const [returnDate, setReturnDate] = useState<any>(new Date());
  const [, setSelectedDays] = useState(0);
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');
  const [accomodation, setAccomodation] = useState('');
  const [tripTypeId, setTripTypeId] = useState(null);
  const [applicantId, setApplicantId] = useState('');
  const [applicantName, setApplicantName] = useState('');

  const [airTicketFile, setAirticketFile] = useState<any>('');
  const [airTicketFilePath, setAirTicketFilePath] = useState('');

  const [airportName, setAirportName] = useState<any>('');
  const [allRespectiveTypes, setAllRespectiveTypes] = useState<any>([]);
  const [allRespectiveTypes_Name, setAllRespectiveTypes_Name] =
    useState<any>('');

  const [reasonsForOtherBusinessType, setReasonsForOtherBusinessType] =
    useState<any>('');
  const [newattachement, setNewAttachement] = useState(false);
  const ticketRequests = [
    { id: 0, name: 'One Way' },
    { id: 1, name: 'Round Trip' },
  ];

  const accomodationTypes = [
    { id: 'Yes', name: 'Yes' },
    { id: 'No', name: 'No' },
  ];

  const handleSetTicketRequest = (ticketName: any) => {
    const getTicket = _.filter(ticketRequests, function (tkt: any) {
      return tkt.name === ticketName;
    });
    if (getTicket.length) {
      const tkt_rqst: any = getTicket[0];

      setTicketRequestId(tkt_rqst.id);
      setTicketRequest(ticketName);
    }
  };

  const airTicketFileUpload = (e: any) => {
    const _file: any = e.target.files[0];
    setNewAttachement(true);
    if (_file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      setAirticketFile(_file);
      setAirTicketFilePath(image_as_base64);
    } else {
      setAirticketFile(_file);
      setAirTicketFilePath('');
      setIsPDF(true);
      setPDFName(_file?.name);
    }
  };
  const handleReturnDate = (value: any) => {
    setReturnDate(value);
    if (travelDate && value) {
      const diffTime = Math.abs(value - travelDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setSelectedDays(diffDays);
    }
  };

  const handleChange = async (event: any) => {
    const selected_row = allTripTypes?.filter(
      (e: any) => e.id == event.target.value,
    )[0];
    setTripTypeId(event.target.value);
    const ticket_type = selected_row?.is_restricted ? 2 : 1;
    const _respectiveTypes = await getEmpTicketTypes(ticket_type);
    setAllRespectiveTypes_Name(trans(selected_row?.name));
    setAllRespectiveTypes(_respectiveTypes);
  };
  const handleAppicantChange = (event: any) => {
    setApplicantId(event.target.value);
    const _x = allRespectiveTypes?.filter((d: any) => {
      return d.id == event.target.value;
    });
    setApplicantName(_x[0].name);
  };
  const handleSubmit = () => {
    const travel_date = travelDate;
    const return_date = returnDate;
    const selected_row = allTripTypes?.filter(
      (e: any) => e.id == tripTypeId,
    )[0];

    callBackGetData({
      trip_type_id: tripTypeId,
      ticket_type: ticketRequestId,
      is_restricted: selected_row?.is_restricted ? true : false,
      travelDate: travel_date,
      returnDate: ticketRequestId == 0 ? '' : return_date,
      destination: countryName,
      applicant: benefitStatus == 'Employee' ? 'Self' : applicantName,
      applicantID: benefitStatus == 'Employee' ? '4' : applicantId,
      attachment: airTicketFile,
      accomodation: accomodation,
      airportname: airportName,
      remarks: remarks,
      amount: amount,
      newattachement: newattachement,
    });
  };
  const handleSetCounty = (countryName: any) => {
    const country = _.filter(allCountries, function (c: any) {
      return c.name === countryName;
    });
    if (country.length) {
      const cnty = country[0];
      setCountryId(cnty.id);
      setCountryName(countryName);
    }
  };
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      overflowY="auto"
      modalHeight="630px"
      modalWidth="700px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Apply Air Ticket') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={6}>
            <Box
              style={{
                height: '430px',
                border: '1px solid #0000001F',
                borderRadius: '15px',
                padding: '20px',
                overflowY: 'auto',
              }}
            >
              <Grid container>
                {isLoading ? (
                  <Loader height={100} width={200} />
                ) : (
                  allTripTypes?.length > 0 && (
                    <>
                      <Grid item xs={12}>
                        <Typography
                          style={{
                            fontFamily: fonts.fontFamily,
                            fontSize: fonts.title,
                            color: themes.blackDefault,
                            fontWeight: 'bold',
                          }}
                        >
                          {trans('Select Trip Type')}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{ marginTop: '0.2em' }}>
                        <RadioGroup
                          name="radio-buttons-group"
                          value={tripTypeId}
                          onChange={handleChange}
                        >
                          {_.map(allTripTypes, (trip: any) => {
                            return (
                              <Box
                                className={
                                  i18n.language == 'en'
                                    ? 'trip_radio_btn'
                                    : 'trip_radio_btn_rtl'
                                }
                              >
                                <FormControlLabel
                                  value={trip.id}
                                  control={
                                    <Radio
                                      sx={{
                                        '&.Mui-checked': {
                                          color: themes.primaryMain,
                                        },
                                      }}
                                    />
                                  }
                                  label={trip.name}
                                />
                              </Box>
                            );
                          })}
                        </RadioGroup>
                      </Grid>
                    </>
                  )
                )}
                {allRespectiveTypes?.length > 0 && (
                  <>
                    <Grid item xs={12} style={{ marginTop: '1em' }}>
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.title,
                          color: themes.blackDefault,
                          fontWeight: 'bold',
                        }}
                      >
                        {trans('Select')} {allRespectiveTypes_Name}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <RadioGroup
                        name="radio-buttons-group"
                        value={applicantId}
                        onChange={handleAppicantChange}
                      >
                        {_.map(allRespectiveTypes, (applicant: any) => {
                          return (
                            <Box
                              className={
                                i18n.language == 'en'
                                  ? 'trip_radio_btn'
                                  : 'trip_radio_btn_rtl'
                              }
                            >
                              <FormControlLabel
                                value={applicant.id}
                                control={
                                  <Radio
                                    sx={{
                                      '&.Mui-checked': {
                                        color: themes.primaryMain,
                                      },
                                    }}
                                  />
                                }
                                label={trans(applicant.name)}
                              />
                            </Box>
                          );
                        })}
                      </RadioGroup>
                    </Grid>
                  </>
                )}
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              style={{
                height: 'auto',
                maxHeight: '430px',
                border: '1px solid #0000001F',
                borderRadius: '15px',
                padding: '20px',
                overflowY: 'auto',
              }}
            >
              <Grid container spacing={3}>
                {tripTypeId == 3 && (
                  <Grid item xs={12}>
                    <CustomTextField
                      type="string"
                      label={trans('Reason')}
                      placeholder={trans('Write Reason')}
                      value={reasonsForOtherBusinessType}
                      onChange={(e: any) =>
                        setReasonsForOtherBusinessType(e.target.value)
                      }
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <CustomAutoComplete
                    label={trans('Ticket Request')}
                    options={_.map(ticketRequests, (ticket: any) => {
                      return trans(ticket.name);
                    })}
                    value={ticketRequest}
                    onChange={(event: any, newValue: any) => {
                      handleSetTicketRequest(newValue);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomAutoComplete
                    label={trans('Destination')}
                    options={_.map(allCountries, (country: any) => {
                      return country.name;
                    })}
                    value={countryName}
                    onChange={(event: any, newValue: any) => {
                      handleSetCounty(newValue);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    type="string"
                    label={trans('Airport Name')}
                    placeholder={trans('Write Airport Name')}
                    value={airportName}
                    onChange={(e: any) => setAirportName(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <DatePickerInput
                    value={new Date(travelDate)}
                    label={trans('Travel Date')}
                    width="100%"
                    onChange={(newValue: Date | string) => {
                      if (newValue > returnDate && ticketRequestId == 1) {
                        toast.error(
                          trans(
                            'Travel date should not be greater than return date',
                          ),
                        );
                      } else {
                        setTravelDate(newValue);
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <DatePickerInput
                    value={new Date(returnDate)}
                    label={trans('Return Date')}
                    width="100%"
                    onChange={(newValue: Date | string) => {
                      if (newValue < travelDate && ticketRequestId == 1) {
                        toast.error(
                          trans(
                            'Return date should be greater than travel date',
                          ),
                        );
                      } else {
                        handleReturnDate(newValue);
                      }
                    }}
                    disabled={ticketRequestId == 0 ? true : false}
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomTextField
                    type="number"
                    label={trans('Amount')}
                    placeholder={trans('Write Amount')}
                    value={amount}
                    onChange={(e: any) => setAmount(e.target.value)}
                  />
                </Grid>
                {tripTypeId == 1 && (
                  <Grid item xs={12}>
                    <CustomAutoComplete
                      label={trans('Accomodation')}
                      options={_.map(accomodationTypes, (_acc: any) => {
                        return trans(_acc.name);
                      })}
                      value={accomodation}
                      onChange={(event: any, newValue: any) => {
                        setAccomodation(newValue ? newValue : '');
                      }}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <CustomTextField
                    type="string"
                    label={trans('Remarks')}
                    placeholder={trans('Write Remarks')}
                    value={remarks}
                    onChange={(e: any) => setRemarks(e.target.value)}
                  />
                </Grid>
                <Grid item xs={8}>
                  <DropAndSelect
                    upload={airTicketFileUpload}
                    src={airTicketFilePath}
                    isPDF={isPDF}
                    pdfName={pdfName}
                    onDelete={() => {
                      setIsPDF(false);
                      setPDFName('');
                      setAirTicketFilePath('');
                      setNewAttachement(false);
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </CompDirection>

      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default ApplyAirTicketPresenter;
